import React from "react";
import PropTypes from "prop-types";
//import styled from 'styled-components';
// const Editor = dynamic(
//   () => import('react-draft-wysiwyg').then(mod => mod.Editor),
//   { ssr: false }
//  )  
import { Editor } from 'react-draft-wysiwyg';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import style1 from "../common/setting.module.scss"

export default function LedEditor({ editorState, setEditorState }) {
  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
  };

  LedEditor.propTypes = {
    editorState: PropTypes.node,
    setEditorState: PropTypes.func,
  };
  
  LedEditor.defaultProps = {
    currentText: "",
    setEditorState: () => null,
  };

  // const uploadImageCallBack = async (file) => {
  //   const imgData = await apiClient.uploadInlineImageForArticle(file);
  //   return Promise.resolve({ data: { 
  //     link: `${process.env.NEXT_PUBLIC_API_URL}${imgData[0].formats.small.url}`
  //   }});
  // }

//   const MyBlock = styled.div`
//     .wrapper-class{
//         width: 100%;
//         margin: 0 auto;
//         margin-bottom: 4rem;
//         margin-top: 0rem;
//     }
//   .editor {
//     height: 100px !important;
//     border: 1px solid #f1f1f1 !important;
//     padding: 0px 5px !important;
//     border-radius: 2px !important;
//     background : #000000;
//     color: #00FF00;
// 		font-size:24px;
//     font-family:"굴림체";
//   }
// `;

  return (
     <div>
        <Editor
          // 에디터와 툴바 모두에 적용되는 클래스
        //   wrapperClassName="wrapper-class"
        //   // 에디터 주변에 적용된 클래스
        editorClassName={style1.editor}
        //  // 툴바 주위에 적용된 클래스
        //   toolbarClassName="toolbar-class"
          toolbar={{
            options: [
              "colorPicker",
              "textAlign",
              // "fontSize",
              // "fontFamily",
              "remove",
              "history",
            ],
            colorPicker: {
              className: undefined,
              component: undefined,
              popupClassName: undefined,
              //inDropdown: false,
              colors: [
                "rgb(255, 0,0)",
                "rgb(0,255, 0)",
                "rgb(0,0,255)",
                "rgb(255, 255,0)",
                "rgb(0,255, 255)",
                "rgb(255,0,255)",
                "rgb(255, 255,255)",
                "rgb(0, 0,0)",
              ],
            },
          }}
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
        //placeholder="문안을 작성해주세요."
        // localization={{
        //   locale: 'ko',
        // }}
        />
     </div>
  )
}
